// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import './status-change-dealer-info.scss';
import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';

const StatusChangeDealerInfo = ({dealer}) =>

    <div className='labeled-string'>
        <span className='data-label'>
            <FormattedMessage id='DEALER'/>
        </span>
        <span className='data-key'>
            <div className='data'>
                {`${dealer.name}, ${dealer.location.city}, ${dealer.location.state}, ${dealer.account}`}
            </div>
            <div className='location'>
                <span className='data'>{dealer.location.address1}</span>
                <span className='data'>{dealer.location.address2}</span>
                <span className='data'>{`${dealer.location.city}, ${dealer.location.state} - ${dealer.location.postalCode}`}</span>
            </div>
        </span>
    </div>;

StatusChangeDealerInfo.displayName = 'StatusChangeDealerInfo';
StatusChangeDealerInfo.propTypes = {
    dealer: PropTypes.instanceOf(Dealer).isRequired
};

export default StatusChangeDealerInfo;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/product-info-view/status-change-dealer-info.js